
import { LayoutGrid, LayoutList } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export type ViewMode = "card" | "list";

interface ViewToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  label?: string;
  className?: string;
}

export const ViewToggle = ({ 
  viewMode, 
  onViewModeChange, 
  label = "View:", 
  className 
}: ViewToggleProps) => {
  return (
    <div className="flex items-center gap-2">
      {label && (
        <span className="text-sm font-medium text-gray-500">{label}</span>
      )}
      <ToggleGroup 
        type="single" 
        value={viewMode} 
        onValueChange={(value) => value && onViewModeChange(value as ViewMode)}
        className={className}
      >
        <ToggleGroupItem value="card" aria-label="Card view">
          <LayoutGrid className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="list" aria-label="List view">
          <LayoutList className="h-4 w-4" />
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
